/**
 * Encode unicode values to base64
 * https://attacomsian.com/blog/javascript-base64-encode-decode
 * https://developer.mozilla.org/en-US/docs/Web/API/btoa
 */

/**
 * Base 64 encode a value to a string accounting for unicode
 * @param value Any json value
 * @returns
 */
const encode = (value: unknown): string => {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  let str = value;
  if (typeof value !== "string") str = JSON.stringify(str);
  return btoa(
    encodeURIComponent(str as string).replace(/%([0-9A-F]{2})/g, function toSolidBytes(_match, p1) {
      return String.fromCharCode(`0x${p1}` as unknown as number);
    })
  );
};

const decode = (value: string): string => {
  return decodeURIComponent(
    atob(value)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

export default {
  encode,
  decode,
};
